module.exports = __webpack_public_path__ + "static/media/bye.7b009d1b.svg";